<script>
export default {
  props: {
    value: { type: String, default: null },
    startTime: {type: String, default: '08:00'},
    endTime: {type: String, default: '20:00'},
    increment: {type: String, default: '30'},  // 30 min
  },

  data() {
    return {
      selectedTime: this.value,
      timeOptions: this.generateTimeOptions()
    };
  },

  watch: {
    value(newVal) {
      this.selectedTime = newVal
    }
  },

  methods: {
    generateTimeOptions() {
      let start = new Date()
      let hm = this.startTime.split(':')
      start.setHours(parseInt(hm[0]), parseInt(hm[1]), 0, 0)

      let end = new Date()
      hm = this.endTime.split(':')
      end.setHours(parseInt(hm[0]), parseInt(hm[1]), 0, 0)

      const times = [];
      while (start <= end) {
        let hours = String(start.getHours()).padStart(2, '0')
        let mins = String(start.getMinutes()).padStart(2, '0')
        times.push(`${hours}:${mins}`)
        start.setMinutes(start.getMinutes() + parseInt(this.increment))
      }

      return times;
    },

    updateTime() {
      this.$emit('input', this.selectedTime);
    }
  }
};
</script>

<template>
    <select v-model="selectedTime" @change="updateTime()">
      <option v-for="time in timeOptions" :key="time" :value="time">
        {{ time }}
      </option>
    </select>
</template>